import { computed } from "vue";
import { useDashboardStore } from "@/modules/dashboards/store";
import PeriodSelectionDTO = App.Data.Explorer.PeriodSelectionDTO;

export function useDashboardState() {
	const dashboardState = useDashboardStore().dashboardState;

	const isEqual = (x, y) => {
		const ok = Object.keys,
			tx = typeof x,
			ty = typeof y;
		return x && y && tx === "object" && tx === ty
			? ok(x).length === ok(y).length &&
					ok(x).every((key) => isEqual(x[key], y[key]))
			: x === y;
	};

	const cardsForWatcher = computed(() => {
		const cards = [];
		dashboardState.dashboard.cards.forEach((card) => {
			const cardCopy = { ...card, ...card.layout };
			delete cardCopy.stored_document;
			delete cardCopy.layout;
			cards.push(cardCopy);
		});
		return cards;
	});

	const dashboardForWatcher = computed(() => {
		const dashboardCopy = { ...dashboardState.dashboard };
		delete dashboardCopy.cards;
		return dashboardCopy;
	});

	// Like dashboardForWatcher, but without presentation-only settings that
	// don't require refetching card data when they change.
	const dashboardForDataWatcher = computed(() => {
		const dashboardCopy = { ...dashboardState.dashboard };
		delete dashboardCopy.cards;
		delete dashboardCopy.legend_width;
		return dashboardCopy;
	});

	const computedPeriodSelection = computed({
		get(): PeriodSelectionDTO {
			return {
				from: dashboardState.dashboard.period_from,
				from_parsed: dashboardState.dashboard.period_from_parsed,
				to: dashboardState.dashboard.period_to,
				to_parsed: dashboardState.dashboard.period_to_parsed,
			};
		},
		set(v: PeriodSelectionDTO) {
			dashboardState.dashboard.period_from = v.from;
			dashboardState.dashboard.period_from_parsed = v.from_parsed;
			dashboardState.dashboard.period_to = v.to;
			dashboardState.dashboard.period_to_parsed = v.to_parsed;
		},
	});

	return {
		isEqual,
		cardsForWatcher,
		dashboardForWatcher,
		dashboardForDataWatcher,
		computedPeriodSelection,
	};
}
